module.exports = __webpack_public_path__ + "img/language-switcher.d48a6a7a.svg";